import axios from "axios";
import { baseUrl } from '../config';

// import store from '../store';

// axios for accounting MD store (for Docker);

const instance = axios.create({
  //  baseURL: "http://localhost:9001/api",
  // baseURL: process.env.VUE_APP_URL,
  // baseURL: 'http://192.168.1.133:9001/api',
  // baseURL: 'http://192.168.1.182:9001/api',
  // baseURL: process.env.VUE_APP_URL_API,
  baseURL: baseUrl,
  timeout: 0,
  headers: {
    accept: "application/json",
    "content-type": "application/json"
  },
});

export default instance;